import { render } from "./ServiceProviderManage.vue?vue&type=template&id=54bd5404"
import script from "./ServiceProviderManage.vue?vue&type=script&lang=js"
export * from "./ServiceProviderManage.vue?vue&type=script&lang=js"

import "./ServiceProviderManage.vue?vue&type=style&index=0&id=54bd5404&lang=less"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__